import React, { Component } from 'react';
import cx from 'classnames';

import { CARD_OVERLAY_FAV_ICON } from '../styles/favourite';
import Icon from '../../Icon';










class Favourite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFavourite: false
    };
  }

  componentDidMount() {
    const { isFavourite } = this.props;

    this.setState({ isFavourite });
  }

  onFavouriteClick = (action) => {
    this.setState((prevState) => ({
      isFavourite: !prevState.isFavourite
    }));

    if (action) {
      action();
    }
  };

  render() {
    const { action } = this.props;
    const { isFavourite } = this.state;

    return (
      <Icon
        onClick={() => this.onFavouriteClick(action)}
        name="favourite"
        color={isFavourite ? 'dandelion' : ''}
        className={cx(
          'favourite-icon',
          CARD_OVERLAY_FAV_ICON
        )} />);


  }
}

export default Favourite;